<template>


  <div id="property-management" class="flex flex-wrap-reverse items-center data-list-btn-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" multiple v-model="selected" :max-items="itemsPerPage" search :data="liveCities">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ properties.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : properties.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th sort-key="code">Name</vs-th>
        <vs-th sort-key="name">Alias</vs-th>
        <vs-th>Action</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.name }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.alias }}</p>
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>

  </div>

</template>

<script>

import vSelect from 'vue-select'
import DataViewSidebar from './DataViewSidebar'
import {mapActions, mapState} from 'vuex'

export default {
  components: {
    'v-select': vSelect,
    DataViewSidebar
  },
  data () {
    return {
      liveCitiesData: [],
      cityId: null,
      name: '',
      is_required: 0,
      is_readonly: 0,
      sidebarData: {},

      selected: [],
      // products: [],
      itemsPerPage: 20,
      isMounted: false,
      addNewDataSidebar: false
    }
  },
  computed: {
    ...mapState('liveCity', ['liveCities']),
    properties () {
      return this.$store.state.liveCity.liveCities
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.properties.length
    }
  },
  mounted () {
    this.getLiveCitiesData()
  },
  methods: {
    ...mapActions('liveCity', ['getLiveCities', 'getLiveCity', 'deleteLiveCity', 'updateLiveCity', 'saveLiveCity']),
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.add = true
      this.toggleDataSidebar(true)
    },
    async deleteData (id) {
      await this.deleteLiveCity({cityId: id})
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      data.cityId = data.id
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    async getLiveCitiesData () {
      this.$vs.loading()
      const getLiveCities = await this.getLiveCities()
      if (getLiveCities.status) {
        this.liveCitiesData = getLiveCities.data
      } else {
        this.openNotify({title: 'Error', icon: 'icon-alert-circle', text: getLiveCities.message, color: 'danger' })
      }
      this.$vs.loading.close()
    }
  }
}

</script>

<style lang="scss">
#property-management{
  .vs--single.vs--open .vs__selected{
    position: initial;
  }
  .vs-table-primary{
    width:100%;
  }
}
</style>
